/**
 * 递归url解码，原始字符串不确认被编码过几次
 * @param remark
 */
export const decodeRemark = (remark: string): string => {
  if (!remark) return '';
  let decodedRemark = remark;

  try {
    decodedRemark = decodeURIComponent(remark);
    // 解码出来结果和原始字符串一致，视为编码完成
    if (decodedRemark === remark) {
      return decodedRemark;
    }

    return decodeRemark(decodedRemark);
  } catch (e) {
    // 解码报错直接返回原始字符串
    return decodedRemark;
  }
};
